import { render, staticRenderFns } from "./ProductionDetail.vue?vue&type=template&id=47ac626e&scoped=true"
import script from "./ProductionDetail.vue?vue&type=script&lang=js"
export * from "./ProductionDetail.vue?vue&type=script&lang=js"
import style0 from "./ProductionDetail.vue?vue&type=style&index=0&id=47ac626e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ac626e",
  null
  
)

export default component.exports